import { HASLang } from './HAS/HAS.lang';

export const componentsLang = {
    HAS: HASLang,
};
